import { t } from '@lingui/macro'
import { AnimatePresence } from 'framer-motion'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTheme } from 'styled-components'

import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { FloatingLayout } from '@/layout/components/floating-layout'
import { FloatingLayoutBox } from '@/layout/components/floating-layout/FloatingLayout.styled'
import { useLeanSubject } from '@/modules/healthblocks/hooks/useLeanSubject'
import { getDropInProps } from '@/modules/shared/animations/dropIn.animation'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'

const ActivatingAccountPage = () => {
  const theme = useTheme()

  const { refresh } = useLeanSubject()

  useEffect(() => {
    const interval = setInterval(() => {
      if (refresh) {
        refresh()
      }
    }, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [refresh])

  return (
    <FloatingLayout image='/img/happy-nurse.jpg' imageGridColumns='3fr 7fr'>
      <Helmet title='MijnZiekenhuis | Onboarding' />

      <AnimatePresence>
        <FloatingLayoutBox key='activating-account' {...getDropInProps()}>
          <P type='BodyLargeRegular' color={theme.Colors.Neutrals.Darkest}>
            {t({
              id: 'onboarding.activate-account.body',
              message: 'Even geduld: we activeren je account.',
            })}
          </P>
          <AnimatedLoader />
        </FloatingLayoutBox>
      </AnimatePresence>
    </FloatingLayout>
  )
}

export { ActivatingAccountPage }
